<template>
	<div class="page needle-heads">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<span class="navigation-title">{{$t('needles-heads')}}</span>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main">
				<form @submit.prevent="calc" ref="form">
					<div class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label for="head-type">{{$t('head-type-?')}}</label>
									<div class="element">
										<div class="flex">
											<select id="head-type" v-model="headType">
												<option value="1">{{$t('1-working-position')}}</option>
												<option value="2">{{$t('2-working-positions')}}</option>
											</select>
										</div>
									</div>
									<label for="needles-number">{{$t('needles-number')}}</label>
									<div class="element">
										<div class="flex">
											<input type="number" placeholder=" " min="0" id="needles-number" v-model="needlesNumber">
										</div>
									</div>
									<label for="production-speed">{{$t('production-speed-?')}}</label>
									<div class="element">
										<div class="flex">
											<input type="number" placeholder=" " min="0" step="any" id="production-speed" v-model="productionSpeed">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
				<hr>
				<div class="container">
					<div class="content">
						<span class="result" v-if="headSpeed <= 2600">{{headSpeed | headSpeedUnit}} {{$t('head-speed-unit')}}</span>
						<span class="result" v-else>{{$t('head-speed-too-high')}}</span>
						<span class="result">{{feedingSpeed | feedingSpeedUnit}} {{$t('feeding-speed-unit')}}</span>
						<!-- <button>{{$t('save')}}</button> -->
					</div>
				</div>
			</section>
		</transition>
	</div>
</template>

<script>
export default {
	data() {
		return {
			headType: "1",
			needlesNumber: '',
			productionSpeed: '',
			headSpeed: '',
			feedingSpeed: ''
		};
	},
	mounted() {
		this.calc();
	},
	watch: {
		headType() {
			this.calc();
		},
		needlesNumber() {
			this.calc();
		},
		productionSpeed() {
			this.calc();
		}
	},
	methods: {
		calc() {
			if (!this.$refs.form.checkValidity()) {
				// Try focus on the error 
				this.$refs.form.reportValidity();
				return;
			}
			let needlesNumber = this.$utils.sanitize(this.needlesNumber);
			let productionSpeed = this.$utils.sanitize(this.productionSpeed);

			if (this.headType === "1") {
				this.headSpeed = productionSpeed * needlesNumber * 48;
				this.feedingSpeed = needlesNumber * productionSpeed * 2.52 / 1;
			} else if (this.headType === "2") {
				this.headSpeed = productionSpeed * needlesNumber * 32;
				this.feedingSpeed = needlesNumber * productionSpeed * 2.52 / 2;
			} else {
				this.headSpeed = 0;
				this.feedingSpeed = 0;
			}
		}
	},
	filters: {
		headSpeedUnit(value) {
			value = value || 0;
			return value.toFixed(0);
		},
		feedingSpeedUnit(value) {
			value = value || 0;
			return value.toFixed(3);
		}
	}
}
</script>